import { AxiosError } from 'axios';
import { MRT_Row } from 'mantine-react-table';
import { FC, useContext, useState } from 'react';

import { Box, Button, FileButton, Group, Popover, Text } from '@mantine/core';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ObjectsDataType } from '@/pages/objects/objects.tsx';

import { AppContext } from '@/contexts/AppContext/AppContextProvider.tsx';

import { bookingObjectsApi } from '@/shared/api/bookingObjects.ts';
import { useShowNotifaction } from '@/shared/hooks/useShowNotifaction.tsx';
import { IRequestError } from '@/shared/types/app.types.ts';
import { IObject } from '@/shared/types/bookingObjects.types.ts';
import IconDelete from '@/shared/uikit/assets/icons/IconDelete.svg?react';
import IconEdit from '@/shared/uikit/assets/icons/IconEdit.svg?react';

import { IconCheck, IconPhoto, IconX } from '@tabler/icons-react';

type Props = {
	row: MRT_Row<ObjectsDataType>;
	handleEdit: (item: IObject) => void;
};

export const ObjectsActions: FC<Props> = ({ row, handleEdit }) => {
	const queryClient = useQueryClient();
	const { admin, moderator } = useContext(AppContext);

	const [isPopoverOpen, setIsPopoverOpen] = useState(false);

	const { mutate: handleUploadObjectImage } = useMutation({
		mutationFn: bookingObjectsApi.uploadObjectImage,
		onSuccess: () => {
			void queryClient.invalidateQueries({ queryKey: ['objects'] });
			useShowNotifaction({ text: 'Изображение загружено', type: 'success' });
		},
		onError: (error: AxiosError<IRequestError>) => {
			useShowNotifaction({
				text: error.response?.data?.message.replace('Unhandled service exception:', '') ?? '', //TODO: убрать костыль
				type: 'error',
			});
		},
	});

	const { mutate: handleDelete } = useMutation({
		mutationFn: bookingObjectsApi.deleteObject,
		onSuccess: () => {
			void queryClient.invalidateQueries({ queryKey: ['objects'] });
			useShowNotifaction({ text: 'Объект удален', type: 'success' });
		},
		onError: (error: AxiosError<IRequestError>) => {
			useShowNotifaction({
				text: error.response?.data?.message.replace('Unhandled service exception:', '') ?? '', //TODO: убрать костыль
				type: 'error',
			});
		},
		onMutate: () => setIsPopoverOpen(false),
	});

	return (
		<Group>
			{row.original.item.type.kind !== 'location' && !admin && (
				<Button
					variant="transparent"
					size="compact-sm"
					radius="sm"
					color="black"
					p={0}
					onClick={() => handleEdit(row.original.item)}
				>
					<IconEdit fontSize={20} color="#667085" cursor="pointer" />
				</Button>
			)}
			{admin && (
				<Button.Group display="flex" style={{ justifyContent: 'left' }}>
					<FileButton
						onChange={(file) => handleUploadObjectImage({ payload: file!, id: row.original.id })}
						accept="image/svg+xml"
					>
						{(props) => <IconPhoto fontSize={20} color="#667085" cursor="pointer" {...props} />}
					</FileButton>
					<Button
						variant="transparent"
						size="compact-sm"
						radius="sm"
						color="black"
						p={0}
						onClick={() => handleEdit(row.original.item)}
					>
						<IconEdit fontSize={20} color="#667085" cursor="pointer" />
					</Button>

					<Popover
						position="top"
						withArrow
						shadow="md"
						opened={isPopoverOpen}
						onChange={setIsPopoverOpen}
					>
						<Popover.Target>
							<Button
								variant="transparent"
								size="compact-sm"
								radius="sm"
								color="balck"
								p={0}
								onClick={() => setIsPopoverOpen((prev) => !prev)}
							>
								<IconDelete
									fontSize={20}
									color="#667085"
									// cursor="pointer"
								/>
							</Button>
						</Popover.Target>
						<Popover.Dropdown p={8}>
							<Box size="xs">
								<Text ta="center" fz={13}>
									Удалить?
								</Text>
								<Button.Group mt={3}>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										onClick={() => handleDelete(row.original.id)}
									>
										<IconCheck size={16} />
									</Button>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										color="red"
										onClick={() => setIsPopoverOpen(false)}
									>
										<IconX size={16} />
									</Button>
								</Button.Group>
							</Box>
						</Popover.Dropdown>
					</Popover>
				</Button.Group>
			)}
		</Group>
	);
};
